import { createSelector } from 'reselect';

export const makeSelectBillingPeriodsState = () => (state) => state.get('billing');

export const makeSelectFetchingBillingPeriods = () => createSelector(
  makeSelectBillingPeriodsState(),
  (substate) => substate.get('fetching')
);

export const makeSelectBillingPeriods = () => createSelector(
  // TODO: Add check that returned substate is not null
  makeSelectBillingPeriodsState(),
  (substate) => {
    const tempSubstate = substate.get('billingPeriods');

    if (tempSubstate) {
      return tempSubstate.toJS()
    }
    return tempSubstate
  }
);

export const makeSelectActiveBillingPeriod = () => createSelector(
  makeSelectBillingPeriodsState(),
  (substate) => {
    const tempSubstate = substate.get('activeBillingPeriod')
    if (tempSubstate) {
      return tempSubstate.toJS()
    }
    return tempSubstate
  }
)

export const makeSelectInvoices = () => createSelector(
  makeSelectBillingPeriodsState(),
  (substate) => substate.get('invoices').toJS()
);

export const makeSelectInvoicesError = () => createSelector(
  makeSelectBillingPeriodsState(),
  (substate) => substate.get('invoicesError')
);

export const makeSelectBillingPeriodsError = () => createSelector(
  makeSelectBillingPeriodsState(),
  (substate) => substate.get('error')
);

export const makeSelectFetchingInvoices = () => createSelector(
  makeSelectBillingPeriodsState(),
  (substate) => substate.get('fetchingInvoices')
);
export const makeSelectZuoraSignature = () => createSelector(
  makeSelectBillingPeriodsState(),
  (substate) => substate.get('zuoraSignature')
);
export const makeSelectSetDefautPaymentMethodFinished = () => createSelector(
  makeSelectBillingPeriodsState(),
  (substate) => substate.get('setDefaultPaymentMethodFinished')
);
